import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/blogs/BlogLayout.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/blogs/EnhancedBlogCard.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
